export const appSettings = {
  'planning_files_url': 'https://demo-planning-be.schemaxtech.in/erpx',
  'masters_url': 'https://demo-masters-be.schemaxtech.in/erpx',
  'sales_url': 'https://demo-sale-service-be.schemaxtech.in/erpx',
  'procure_url': 'https://demo-procurement-service-be.schemaxtech.in/erpx',
  'warehouse_url': 'https://demo-warehouse-service-be.schemaxtech.in/erpx',
  'logistics_url': 'https://demo-logistics-be.schemaxtech.in/erpx',
  'ums_url': 'https://demo-backend-be.schemaxtech.in/erpx',
  'rm_procure_url': 'https://demo-rmprocurement-be.schemaxtech.in/erpx',
  'transport_url': 'https://demo-transportation-be.schemaxtech.in/erpx',
  'production_url': 'https://demo-production-be.schemaxtech.in/erpx',
  'assets_url': 'http://139.59.65.145:6010/erpx',
  'hrms_url': 'https://demo-hrms-be.schemaxtech.in/erpx',
  'planning_url': 'https://demo-planning-be.schemaxtech.in/erpx',
  'anlytics_url': 'https://demo-analytics-be.schemaxtech.in/erpx',
  'bulljobs_url': 'http://139.59.65.145:6014/erpx',
  'bulljobs_manager_url': 'http://139.59.65.145:6015/erpx',
  'vms_url':'http://139.59.65.145:6016/erpx',
  'cms_url': 'http://139.59.65.145:6017/erpx',
  'logs_url':'https://demo-user-logs-be.schemaxtech.in/erpx',
  'enquiry_url':'https://demo-enquiry-management-be.schemaxtech.in/erpx',
  'finance_url':'https://demo-finance-be.schemaxtech.in/erpx',
  'dashboard_url':'https://demo-dashboards.schemaxtech.in/#',
  'dbhost': '206.189.138.212',
  'dbuser': 'demo_prod_user',
  'dbpassword': 'demo@!123',
  'analytics_db': 'demo_erpx_dev_analytics',
  'masters_db': 'demo_erpx_dev_masters',
  'sales_db': 'demo_erpx_dev_sales',
  'procure_db': 'demo_erpx_dev_procurement',
  'warehouse_db': 'demo_erpx_dev_warehouse',
  'logistics_db': 'demo_erpx_dev_logistics',
  'ums_db': 'demo_erpx_dev_ums',
  'rm_procure_db': 'demo_erpx_dev_rm_procurement',
  'transport_db': 'demo_erpx_dev_transport',
  'production_db': 'demo_erpx_dev_production',
  'assets_db': 'demo_erpx_dev_assets',
  'hrms_db': 'demo_erpx_dev_hrms',
  'planning_db': 'demo_erpx_dev_planning',
  'vms_db': 'visitor_management',
  'cms_db': 'demo_erpx_dev_cms',
  'logs_db':'demo_erpx_dev_logs',
  'whatsapp_db':'demo_whatsapp_bi',
  'enquiry_db':'demo_erpx_dev_enquiries',
  'finance_db':'demo_erpx_dev_finance',
  'masters_port': '6001',
  'sales_port': '6002',
  'procurement_port': '6003',
  'warehouse_port': '6004',
  'logistics_port': '6005',
  'ums_port': '6006',
  'rm_procurement_port': '6007',
  'transport_port': '6008',
  'production_port': '6009',
  'assets_port': '6010',
  'hrms_port': '6011',
  'planning_port': '6012',
  'analytics_port': '6013',
  'bulljobs_port': '6014',
  'bulljobs_manager_port': '6014',
  'vms_port':'6016',
  'cms_port': '6017',
  'logs_port':'6022',
  'enquiry_port':'6019',
  'finance_port':'6020',
  'file_upload_path': 'http://139.59.65.145/bmr_live/dist/apps/services/', 
  'logistics_doc_upload_path': 'http://139.59.65.145/bmr_live/dist/apps/services/logistics/', 
  'brand_file_path': 'http://139.59.65.145/bmr_live/dist/apps/services/masters/', 
  'whatsapp_redirection_url': 'http://dev.schemaxtech.in/#',
  'whatsapp_notification_url': 'http://139.59.65.145:3000',
  'whatsapp_broadcast_url': 'http://206.189.138.212:3235/api',
 'tally_upload_files':"http://139.59.65.145/bmr_live/tally-integration",
 
}

export default appSettings;

